import i18n from "i18next";
import {initReactI18next} from "react-i18next";

import fr from '@/locales/fr.json';
import en from '@/locales/en.json';
import es from '@/locales/es.json';
import it from '@/locales/it.json';
import pt from '@/locales/pt.json';
import de from '@/locales/de.json';

i18n
    .use(initReactI18next)
    .init({
        resources: {
            fr: {translation: fr},
            en: {translation: en},
            es: {translation: es},
            it: {translation: it},
            pt: {translation: pt},
            de: {translation: de}
        },
        lng: "fr",
        fallbackLng: "en",

        detection: {
            order: ['querystring', 'localStorage', 'navigator', 'htmlTag'],
            lookupLocalStorage: 'i18nextLng',
            caches: ['localStorage']
        },

        interpolation: {
            escapeValue: false
        }
    });

export default i18n;